import React from 'react'
import type { Website } from '@app/types'

// Cell
export function Cell(props: Website & { lastItem?: boolean }) {
  return (
    <li
      className={`${
        props.lastItem ? '' : 'border-b '
      }w-full px-3 py-2 dark:border-gray-600 text-gray-800 dark:text-gray-200`}
    >
      {props?.domain}
    </li>
  )
}
